import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import useAgencyProvider from '@hooks/useAgencyProvider'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { AgencyProviderModel } from '@domain-group/realhub-backend-api-types'
import type { ServiceModel } from '@domain-group/realhub-backend-api-types'
import AgencyProvider from './AgencyProvider'

interface AgencyProviderGroupProps {
  agencyId: number,
  groupedAgencyProviders?: AgencyProviderModel[],
  service?: ServiceModel,
}

const AgencyProviderGroup = (props: AgencyProviderGroupProps) => {
  const { agencyId, groupedAgencyProviders, service } = props
  const {
    id: serviceId,
    title: serviceTitle,
  } = service || {}

  const {
    callbacks: { createOrEditAgencyProvider },
  } = useAgencyProvider({ agency_id: agencyId, service_id: serviceId })

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px solid', fontSize: 'small', paddingX: 'large', marginTop: 'large',
      }}
      disableHover
      flexDirection="column"
    >
      <Box justifyContent="space-between">
        <Text color="bodyFontLightColor" fontSize="small">{serviceTitle}</Text>

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          <Link
            greyLink
            onClick={() => createOrEditAgencyProvider()}
          >
            <FontAwesomeIcon icon={faPlus} /> Add Provider
          </Link>
        </ScopedConditionalContent>

      </Box>

      {/*
       // @ts-expect-error TS18048 */}
      {groupedAgencyProviders.map(agencyProvider => (
        <AgencyProvider key={agencyProvider.id} agencyProvider={agencyProvider} />
      ))}
    </ListItem>
  )
}

AgencyProviderGroup.propTypes = {
  agencyId: PropTypes.number,
  groupedAgencyProviders: PropTypes.array,
  service: PropTypes.object,
}

export default AgencyProviderGroup
